import { config } from "@shared/config";
import { AppName } from "@shared/constants/app-name";

export const useAppName = () => {
  const name = config.VITE_MC_APP_NAME as string;

  return {
    name,
    isNatalConnect: name.toLowerCase() === AppName.NatalConnect.toLowerCase(),
    isMobilityCare:
      name.toLowerCase() === AppName.MobilityCare.toLowerCase() ||
      name.toLowerCase() === AppName.MobilityCareAfrica.toLowerCase(),
    isMobilityCareAfrica:
      name.toLowerCase() === AppName.MobilityCareAfrica.toLowerCase(),
    isDispatch: name.toLowerCase() === AppName.Dispatch.toLowerCase(),
    isAdmin: name.toLowerCase() === AppName.Admin.toLowerCase(),
  };
};
